import { render, staticRenderFns } from "./CompanyRequisitesView.vue?vue&type=template&id=83d3d814&"
import script from "./CompanyRequisitesView.vue?vue&type=script&lang=ts&"
export * from "./CompanyRequisitesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports